import { render, staticRenderFns } from "./ModalInserirCamera.vue?vue&type=template&id=edacaaee&scoped=true"
import script from "./ModalInserirCamera.vue?vue&type=script&lang=js"
export * from "./ModalInserirCamera.vue?vue&type=script&lang=js"
import style0 from "./ModalInserirCamera.vue?vue&type=style&index=0&id=edacaaee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edacaaee",
  null
  
)

export default component.exports